export default __webpack_public_path__ + "assets/models/a765d4554e23cf3d362c47b64394d6be.glb";